<!-- @format -->

<template>
    <div class="gst-banner d-flex justify-center align-center">
        <slot name="content">
            <div class="gst-banner-content d-flex flex-column align-center pa-3">
                <span
                    v-if="$slots.title"
                    class="gst-banner-content_title">
                    <slot name="title" />
                </span>
                <span
                    v-if="$slots.description"
                    class="gst-banner-content_description">
                    <slot name="description" />
                </span>
            </div>
        </slot>
    </div>
</template>

<script>
export default {
    name: 'BaseBanner',
};
</script>

<style lang="scss" scoped>
@import '@scssMixins';
@import '@scssVariables';

.gst-banner {
    width: 100%;
    border-radius: border-radius('m');

    .gst-banner-content {
        font-weight: font-weight('medium');
        gap: theme-spacing(1);

        .gst-banner-content_title {
            font-size: font-size('s');
            letter-spacing: -0.25px;
        }

        .gst-banner-content_description {
            font-size: font-size('xxxl');
            letter-spacing: -0.357px;
        }
    }
}
</style>
